import axios from 'axios';
import {getApiConfig} from '../config/configProvider';

const getBaseUrl = () => {
  const config = getApiConfig();
  return (config && config.signupUrl) || '/api/account-signup/api/v1/signup';
};

export default class CreateSignupApi {
  static initSignup(lat, lng, headers) {
    return axios
      .post(`${getBaseUrl()}`, {lat, lng, source: 'MOBILE_APP'}, {headers})
      .then(res => res.data);
  }

  static uploadDocuments(id, files, location, headers) {
    const formData = new FormData();
    files.forEach(file => formData.append('files', file));
    const params = {};
    if (location) {
      params.lat = location.lat;
      params.lng = location.lng;
    }
    return axios
      .post(`${getBaseUrl()}/${id}/document`, formData, {
        headers: {...headers, 'Content-Type': 'multipart/form-data'},
        params,
      })
      .then(res => res.data);
  }

  static deleteDocument(id, documentId, headers) {
    return axios
      .delete(`${getBaseUrl()}/${id}/document/${documentId}`, {headers})
      .then(res => res.data);
  }

  static getSignup(id, headers) {
    return axios.get(`${getBaseUrl()}/${id}`, {headers}).then(res => res.data);
  }

  static updateField(id, fieldName, value, headers) {
    return axios
      .put(`${getBaseUrl()}/${id}/resolved/${fieldName}`, {value}, {headers})
      .then(res => res.data);
  }

  static submitSignup(id, headers) {
    return axios
      .post(`${getBaseUrl()}/${id}/submit`, null, {headers})
      .then(res => res.data);
  }
}
